import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UTMdataFilter } from "../../../../helper";
import { fetchGraphUTMMedium } from "./utmMediumAPI";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  visitors: [],
  percentBooking: [],
  percentBought: [],
  weeks: [],
  labels: [],
};

export const graphUTMMedium = createAsyncThunk(
  "utmMedium/visitors",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-utm_medium`;
      const response = await fetchGraphUTMMedium(dbpath, user, 'graph-utm_medium');
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const utmMediumSlice = createSlice({
  name: "utmMedium",
  initialState,
  reducers: {
    resetutmMedium: (state, action) => {
      return { ...initialState };
    },
    setUniqueEngaged: (state, action) => {
      state.uniqueEngaged = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphUTMMedium.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphUTMMedium.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        // console.log(result);
        try {
          state.data = result;
          const resultData = utmMediumHandler(result, "utm_medium=");
          state.visitors = resultData.visitors.reverse();
          state.percentBooking = resultData.percentBooking.reverse();
          state.percentBought = resultData.percentBought.reverse();
          state.weeks = resultData.weeks.reverse();
          state.labels = resultData.labels.reverse();
        } catch (error) {
          // console.warn("UTMMedium data not found!", error)
        }

      })
      .addCase(graphUTMMedium.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const {resetutmMedium} = utmMediumSlice.actions;


export const SelectVisitors = (state) => state.utmMedium.visitors;
export const SelectPercentBooking = (state) => state.utmMedium.percentBooking;
export const SelectPercentBought = (state) => state.utmMedium.percentBought;
export const SelectLabels = (state) => state.utmMedium.labels;
export const SelectWeeks = (state) => state.utmMedium.weeks;
export const SelectUTMMediumStatus = (state) => state.utmMedium.status;

export default utmMediumSlice.reducer;

export const utmMediumHandler = (data, utmParam) => {
  let resultObj = {
    weeks: [],
    visitors: [],
    percentBooking: [],
    percentBought: [],
    labels: [],
  };

  const resultData =  UTMdataFilter(data, resultObj, utmParam);
  return resultData;
};

